<template>
  <div class="flip-device">
    <h2 class="flip-device__title">Переверните устройство<br>в&nbsp;вертикальное положение</h2>
    <div class="flip-device__icon">
      <img src="/frontend/assets/i/flip-phone.svg"/>
    </div>
  </div>
</template>

<script>

export default {
  name: "MobileHorizontal",
  props: {
    show: {type: Boolean, default: false}
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/base/_settings.scss";

.flip-device {
  top: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #E5F0FD;

  pointer-events: none;
  z-index: 90000;

  @include landscape {
    display: flex;
  }

  &__title {
    font-size: 26px;
    line-height: 1.2;
    font-weight: bold;
    margin-bottom: 45px;
    color: $brand-color;
    text-transform: uppercase;
    text-align: center;
  }

  &__icon {
    width: 100px;
    height: 100px;
    min-height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    background: $white-true;
    box-shadow: 0 0 50px rgba($brand-color, 0.3);

    & img {
      width: 30px;
      height: 28px;
    }
  }
}
</style>
